export const SET_SUPPLIER_NOTES = 'SET_SUPPLIER_NOTES'
export const PENDING_SUPPLIER_NOTES_ACTION = 'PENDING_SUPPLIER_NOTES_ACTION'
export const COMPLETED_SUPPLIER_NOTES_ACTION = 'COMPLETED_SUPPLIER_NOTES_ACTION'
export const RESET_SUPPLIER_NOTES_ACTION = 'RESET_SUPPLIER_NOTES_ACTION'
export const SET_SUPPLIER_NOTE = 'SET_SUPPLIER_NOTE'
